import React, { useState, useEffect } from "react";
import arrowLink from "../images/arrowLink.svg";
import { motion } from "framer-motion";
// styling
import { linkFlex, navFlex } from "./GlobalStyle";
import styled from "styled-components";

//for fetching coin data
import axios from "axios";
import { EthereumCoin, SingleCoin } from "../coinapiConfig/api";
import { MotionConfig } from "framer-motion";

function BottomNav() {
  const [coins, setCoins] = useState();
  const [ethereum, setEthereum] = useState();
  const [loading, setLoading] = useState(false);

  // fetching bitcoin data --start
  const fetchCoins = async () => {
    setLoading(true);
    const { data } = await axios.get(SingleCoin);
    setCoins(data);
    setLoading(false);
  };
  useEffect(() => {
    setInterval(() => {
      fetchCoins();
    }, 1000);
  }, []);
  // fetching bitcoin data --end

  // fetching ethereum data --start
  const fetchEthereum = async () => {
    setLoading(true);
    const { data } = await axios.get(EthereumCoin);
    setEthereum(data);
    setLoading(false);
  };
  // console.log("ethereumlist", ethereum);
  useEffect(() => {
    setInterval(() => {
      fetchEthereum();
    }, 1000);
  }, []);
  // fetching ethereum data --end

  // if (!coins || !ethereum) return <div>Coinsloading</div>;
  function numberWithCommas(x) {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  }

  return (
    <motion.div
      initial={{ x: "-99.999vw" }}
      whileInView={{ x: 0 }}
      transition={{
        type: "spring",
        stiffness: 500,
        mass: 4,
        damping: 50,
        delay: 1.5,
      }}
    >
      <BottomNavStyle>
        {/* links  */}
        <div className="block link links">
          <a
            className="link"
            href="mailto: folaborn2013@gmail.com?subject=Hello Samuel"
            target="_blank"
          >
            <div>Email</div>
            <img src={arrowLink} alt="my-email" />
          </a>
          <a
            className="link"
            href="https://www.linkedin.com/in/samuel-afolabi/"
            target="_blank"
          >
            <div>Linkedin</div>
            <img src={arrowLink} alt="linkedin" />
          </a>
          <a
            className="link"
            href="https://github.com/samuelafolabi"
            target="_blank"
          >
            <div>GitHub</div>
            <img src={arrowLink} alt="github" />
          </a>
          <a
            className="link touch-display"
            href="https://samuelafolabi.hashnode.dev/"
            target="_blank"
          >
            <div>blog</div>
            <img src={arrowLink} alt="my-email" />
          </a>
        </div>
        {/* links  */}
        {/* owe-block  */}
        <div className="block mail">
          <div style={{ fontStyle: "italic" }}>folaborn2013@gmail.com</div>
        </div>
        {/* owe-block  */}
        {/* Cryptoblock  */}
        <div className="block link links coins">
          {/* bitcoin  */}
          <div className="link links">
            {coins ? (
              <>
                {" "}
                <div>{coins?.symbol}</div>
                <div>
                  ${numberWithCommas(coins?.market_data.current_price.usd)}
                </div>{" "}
              </>
            ) : (
              "+++ +++"
            )}
          </div>
          {/* bitcoin  */}
          {/* ethereum */}
          <div className="link links">
            {ethereum ? (
              <>
                <div>{ethereum?.symbol}</div>
                <div>
                  ${numberWithCommas(ethereum?.market_data.current_price.usd)}
                </div>
              </>
            ) : (
              "+++ +++"
            )}
          </div>
          {/* ethereum */}
        </div>
        {/* Cryptoblock  */}
      </BottomNavStyle>
    </motion.div>
  );
}

export default BottomNav;

// styling
export const BottomNavStyle = styled.div`
  @media (hover: none) {
    .block {
      width: 100% important;
      margin-left: 10px;
    }
    .touch-display {
      display: flex !important;
    }
  }
  ${navFlex}
  .link {
    ${linkFlex};
    color: inherit;
  }
  .touch-display {
    display: none;
  }
  .links {
    gap: 0.5rem;
  }
  .block {
    width: calc(100% / 3);
  }
  .coins {
    justify-content: flex-end;
  }
  .mail {
    display: flex;
    justify-content: center;
  }
  @media only screen and (max-width: 600px) {
    .links {
      font-size: 1.6rem;
    }
    img {
      width: 2.8rem;
    }
  }
`;
